const BasicInformation = ({ profile, handleChange }) => {
  return (
    <div className="bg-white shadow sm:rounded-lg border border-gray-100 overflow-hidden transform transition-all duration-300 hover:shadow-md">
      <div className="px-4 py-5 sm:px-6 bg-gradient-to-r from-primary-50 to-white">
        <h2 className="text-lg font-medium text-gray-900 flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2 text-primary-600"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
          </svg>
          Basic Information
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          Define the purpose and scope of this assessment profile
        </p>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
        <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div className="sm:col-span-3">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Profile Name<span className="text-red-600 ml-1">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <input
                type="text"
                id="name"
                name="name"
                required
                className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm 
                      focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm 
                      transition duration-150 ease-in-out hover:border-primary-400"
                placeholder="e.g., Electrician Assessment Profile"
                defaultValue={profile ? profile.name : ""}
                onChange={(e) => {
                  const value = e.target.value;
                  profile.name = value;
                  handleChange(profile, "basic");
                }}
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <p className="mt-1 text-xs text-gray-500">
              Choose a descriptive name that clearly identifies the profile's
              purpose
            </p>
          </div>

          <div className="sm:col-span-3">
            <label
              htmlFor="scope"
              className="block text-sm font-medium text-gray-700"
            >
              Profile Scope<span className="text-red-600 ml-1">*</span>
            </label>
            <select
              id="scope"
              name="scope"
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm 
                    focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm
                    transition duration-150 ease-in-out hover:border-primary-400"
              value={
                profile && profile.scope
                  ? profile.scope.toLowerCase()
                  : "technical trade"
              }
              onChange={(e) => {
                const value = e.target.value;
                profile.scope = value;
                handleChange(profile, "basic");
              }}
            >
              <option value="">Job category</option>
              <option value="department">Department</option>
              <option value="seniority level">Seniority level</option>
              <option value="technical trade">Technical trade</option>
              <option value="custom">Custom</option>
            </select>
            <p className="mt-1 text-xs text-gray-500">
              Select the category this profile belongs to
            </p>
          </div>

          <div className="sm:col-span-6">
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700"
            >
              Description
            </label>
            <textarea
              rows="3"
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm 
                    focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm
                    transition duration-150 ease-in-out hover:border-primary-400"
              placeholder="Describe the purpose of this profile and when it should be used"
              defaultValue={profile ? profile.description : ""}
              onChange={(e) => {
                const value = e.target.value;
                profile.description = value;
                handleChange(profile, "basic");
              }}
            />
            <p className="mt-1 text-xs text-gray-500">
              Add details about what positions this profile is intended for and
              any special considerations
            </p>
          </div>

          <div className="sm:col-span-6">
            <div className="bg-blue-50 p-4 rounded-md border border-blue-100 flex items-start transform transition-all duration-300 hover:shadow-sm">
              <div className="flex-shrink-0 mt-0.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-blue-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-blue-800">
                  Default Profile
                </h3>
                <div className="mt-2 text-sm text-blue-700">
                  <label
                    htmlFor="isDefault"
                    className="flex items-center cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded transition duration-150 ease-in-out"
                      checked={profile && profile.is_default}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        profile.is_default = checked;
                        handleChange(profile, "basic");
                      }}
                    />
                    <span className="ml-2">
                      Make this the default profile for new jobs
                    </span>
                  </label>
                  <p className="mt-1 ml-6 text-xs text-blue-600">
                    When enabled, this profile will be automatically assigned to
                    new jobs unless another profile is specifically selected
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInformation;
